import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Peer {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async getPeers() {
        const res = await this.base.get('/api/peers');
        const result = res.data;
        return result;
    }
    async getVersion() {
        const res = await this.base.get('/api/peers/version');
        const result = res.data;
        return result;
    }
    async getInfo() {
        const res = await this.base.get('/api/peers/info');
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=peer.js.map